import { Component, OnInit } from '@angular/core';
import { Company } from '../../../models/company';

import { ModalService } from '../../../services/modal.service';
import { CompanyService } from '../../../services/company.service';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';

import { saveAs as importedSaveAs } from 'file-saver';

import * as moment from 'moment';
import { Page } from '../../../models/paging/page';
import { ExpiredReportService } from '../../../services/expired-report.service';
import { CheckUserType } from '../../../models/checkUserType';
import { ColumnService } from '../../../services/ColumnService';

@Component({
  selector: 'app-expired-report',
  templateUrl: './expired-report.component.html',
  styleUrls: ['./expired-report.component.css']
})
export class ExpiredReportComponent implements OnInit {
  role = new CheckUserType();
  client;

  modalService: ModalService;
  companyService: CompanyService;
  companies: Company[];
  companyList: Company[];

  filter: any = {
    company_Id: 0,
    expiry_Status: 0,
    quick_Search: ''
  };

  viewtype: 0;
  page = new Page();
  rows = Array<any>();
  init: boolean;

  cylinder_Id: string;
  cylinder_Serial_No: string;
  showHistory: boolean = false;

  showFillBatchCyl: boolean = false;
  fill_Batch_ID: string;

  availableOptions: string[] = ['Batch #', 'Tag ID', 'Cylinder Size', 'Cylinder EOL', 'Valve EOL', 'Valve Serial #',
    'Valve Model #', 'Batch Expiry Date', 'Cylinder Serial #', 'Fill Pressure', 'Product Type'];authService: any;
;
  selectedOptions: string[] = ['Batch #', 'Tag ID', 'Cylinder EOL', 'Valve EOL', 'Valve Serial #',
    'Valve Model #', 'Batch Expiry Date', 'Cylinder Serial #', 'Product Type'];

  constructor(authService: AuthService, public expiredReportService: ExpiredReportService, companyService: CompanyService, 
    modalService: ModalService, private columnService: ColumnService, public router: Router) {
    this.client = authService.currentUser.value;
    this.role.initClient(this.client.role);

    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'desc';
    this.page.sortBy = "";

    this.modalService = modalService;

    companyService.getAll(0).then((data) => {
      this.companyList = data;
      this.companies = this.companyList;

      if (this.role.isStandard || this.role.isMasterStandard || this.role.isAdmin) {
        this.filter.company_Id = this.client.companyId;
      }

    });

  }

  ngOnInit() {
    this.getcolumns();
    this.loadTable(this.page);
    this.init = true;
  }

  openFillBatchCylPopup(row) {
    this.showFillBatchCyl = true;
    this.fill_Batch_ID = row.fill_Batch_ID;

    this.modalService.open('popup-fill-batch-cyl');
  }

  closeFillBatchCylPopup() {
    this.showFillBatchCyl = false;
    this.modalService.close('popup-fill-batch-cyl');
  }

  openCylHistoryPopup(row) {
    this.showHistory = true;
    this.cylinder_Id = row.cylinder_ID;
    this.cylinder_Serial_No = row.cyl_Serial_Num;

    this.modalService.open('popup-cyl-history');
  }

  closeCylHistoryPopup(): void {
    if (!this.showHistory) {
      return;
    }
    this.showHistory = false;
    this.modalService.close('popup-cyl-history');
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  // ###################################
  // Filters
  // ###################################
  onExpiryStatusChange(value) {

  }

  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {

    if (!event.column.prop) {
      return false;
    }

    const sortMapping = {
      'cyl_EOL': 'cyl_EOL_Unformatted',
      'valve_EOL': 'valve_EOL_Unformatted',
      'expiry_Date': 'expiry_Date_Unformatted',
    };

    const sortOrder = event.newValue;
    const sortBy = sortMapping[event.column.prop] || event.column.prop;

    this.page.sortOrder = sortOrder;
    this.page.sortBy = sortBy;

    this.loadTable(this.page);
  }


  loadTable(page: Page) {
    this.expiredReportService.getResults(this.page, this.filter.company_Id, this.filter.expiry_Status, this.role.isStandard, this.filter.quick_Search).then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;
      if (this.init) {
        this.gotoTop();
        this.init = false;
      }
    });
  }



  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable(this.page);
  }

  generateExcel() {
    this.expiredReportService.getExcel(this.filter.company_Id, this.filter.expiry_Status, this.role.isStandard, this.page.sortBy, this.page.sortOrder, this.filter.quick_Search ).then((data) => {
      importedSaveAs(data, 'Expired_Cylinders_&_Valves.xlsx');
    });
  }

  gotoTop() {
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  getcolumns() {
    this.columnService.getColumns(this.client.userId, "expiredReport").then((data) => {
      if (data.columns != null) {
        this.selectedOptions = this.availableOptions.filter(c => {
          return data.columns.includes(c);
        });
      }

    });
  }

  saveSelection() {
    this.columnService.save(this.client.userId, "expiredReport", this.selectedOptions).then((data) => {
    });
  }
}

